import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const InnovatingforTomorrow = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h1 className="banner-title">Innovating for Tomorrow</h1>
          <p>
            Empowering businesses with cutting-edge software and analytics
            <br /> solutions that drive growth, enhance operational efficiency,
            and unlock the potential for future success.
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/i-have-very-good-idea_329181-716.jpg"
          alt="Insurance Analytics Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center">Overview</h2>
              <p className="text-center">
                At Innovating for Tomorrow, we empower businesses with advanced
                software solutions, data analytics, and AI-driven technologies
                to stay ahead of the curve. Our mission is to streamline
                operations, enhance decision-making, and drive sustainable
                growth by leveraging the power of innovation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid bg-light" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Case Studies</h2>
              <p className="text-center mb-0">
                Here are a few real-world examples where our innovative
                solutions made a significant impact on business outcomes
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Retail Chain Efficiency</h4>
              <p className="mb-4">
                By implementing our AI-driven analytics platform, this retail
                chain was able to optimize inventory management and streamline
                supply chain operations, reducing operational costs by 25%. As a
                result, they increased efficiency by 40% and improved customer
                satisfaction by ensuring better product availability.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Financial Services Automation</h4>
              <p className="mb-4">
                Our automation tools helped a financial services company
                eliminate manual data entry processes, cutting processing time
                by 30%. The result was faster response times for customers and a
                significant reduction in human error, ultimately improving
                customer retention rates.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Healthcare Data Analytics</h4>
              <p className="mb-4">
                In the healthcare industry, we implemented a predictive
                analytics platform that forecasted patient outcomes, leading to
                better resource allocation and reducing emergency room
                congestion by 20%. Hospitals were able to optimize staffing
                schedules and improve patient care through timely intervention.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">E-commerce Personalization</h4>
              <p className="mb-4">
                We helped an e-commerce platform implement advanced machine
                learning algorithms for personalized product recommendations.
                This led to a 35% increase in customer engagement and a 25%
                boost in sales by offering tailored shopping experiences based
                on user behavior and preferences.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 bg-black text-white pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Transform?</h2>
                <p className="mt-3">
                  Schedule a consultation today to explore how we can empower
                  your growth
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Insurance Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InnovatingforTomorrow;
